module.exports = __webpack_public_path__ + "static/media/Jessie.44180278.png";